module.exports = __webpack_public_path__ + "static/media/next.0f9fb478.svg";